export default function FlightsHeaderBaseController(
    $scope,
    $state,
    $rootScope,
    flightsFactory,
    flightsService,
    userService,
    l10nService,
    baseEvents,
    flightsUtils,
    timeService,
    previousState,
) {
    'ngInject';

    const regionalSettings = userService.getRegionalSettings();

    $scope.module = flightsFactory.getModule();
    $scope.isFlights = flightsFactory.isFlights();
    $scope.isTrains = flightsFactory.isTrains();
    $scope.isUkRail = flightsFactory.isUkRail();
    $scope.labels = flightsFactory.getLabels();
    $scope.options = flightsFactory.options;
    $scope.params = flightsFactory.params;
    $scope.tempParams = angular.copy(flightsFactory.params);
    $scope.isMultitrip = flightsUtils.isMultiTripFlight($scope.params.flightType);

    $scope.isCurrentDay = flightsService.isCurrentDay;
    $scope.workingHoursRestriction = userService.getUser().WorkingHoursRestriction;

    // Format departure and return date
    const convertedDepartureDate = timeService.getDateInUserRegionFormatOrCurrentDate(
        $scope.params.TicketSearchSegments[0]._date
    );
    let convertedReturnDate = timeService.getDateInUserRegionFormatOrCurrentDate(
        $scope.params.TicketSearchSegments[0]._date);

    if (flightsUtils.isRoundTripOrMultiTripFlight($scope.params.flightType)) {
        convertedReturnDate
            = timeService.getDateInUserRegionFormat($scope.params.TicketSearchSegments[1]._date)
            .format(regionalSettings.mediumDayMonthDateFormat);
    }

    $scope.flights = flightsFactory.getFlights();

    if (/checkout/.test(previousState.name) || _.isEmpty($scope.flights)) {
        return $state.go('main.' + flightsFactory.getModule() + '.roundtrip');
    }

    $scope.headerAll = {
        Total: $scope.flights.Total,
        FilteredTotal: $scope.flights.FilteredTotal,
        TotalPassengerCount: +$scope.params.Travelers.Adult.value + +$scope.params.Travelers.Infant.value + +$scope.params.Travelers.Child.value,
        convertedDepartureDate,
        convertedReturnDate,
        route: flightsUtils.calculateRoute($scope.params.TicketSearchSegments, $scope.params.flightType),
        dates: flightsUtils.calculateDates($scope.params.TicketSearchSegments, $scope.params.flightType),
    };

    const initialDepartDate = timeService.getDateInUserRegionFormatOrCurrentDate(
        $scope.params.TicketSearchSegments[0]._date);
    const initialReturnDate = timeService.getDateInUserRegionFormatOrCurrentDate(
        $scope.params.TicketSearchSegments[1]._date);

    $scope.dateOptions = {
        optionsDepart: {
            placeholder: l10nService.localize('Depart date'),
            required: true,
            months: 2,
            start: initialDepartDate,
            after: moment().add({days: -1}),
            before: flightsFactory.getMaxBookDate(),
            dependentPikers: ['dateOptions.optionsReturn'],
        },
        optionsReturn: {
            placeholder: l10nService.localize('Return date'),
            required: true,
            months: 2,
            start: initialReturnDate,
            before: flightsFactory.getMaxBookDate(),
            after: moment(initialDepartDate).add({days: -1}),
        },
    };

    // Header is collapsed initially
    $scope.state = {
        showHeader: true,
    };

    $scope.$watch('state.showHeader', function(newValue) {
        if (newValue) {
            $scope.tempParams = angular.copy($scope.params);
            $scope.dateOptions.optionsReturn.after = moment(initialDepartDate).add({days: -1});
        }
    });

    $scope.$watch('tempParams.TicketSearchSegments[0]._date', resetDateIfEarlierThanDeparture);

    $scope.edit = edit;
    $scope.toggleFiltersFlight = toggleFiltersFlight;
    $scope.findFlights = findFlights;
    $scope.swapLocationsInAllSegments = swapLocationsInAllSegments;

    function resetDateIfEarlierThanDeparture() {
        if ($scope.tempParams.flightType === 'roundtrip') {
            const departDate = moment(
                $scope.tempParams.TicketSearchSegments[0]._date,
                regionalSettings.dateFormat
            );
            const returnDate = moment(
                $scope.tempParams.TicketSearchSegments[1]._date,
                regionalSettings.dateFormat
            );
            if (departDate.isAfter(returnDate)) {
                $scope.tempParams.TicketSearchSegments[1]._date = null;
            }
        }
    }

    function findFlights() {
        flightsFactory.findFlights($scope.tempParams)
            .then(() => $state.go($state.current, {}, {reload: true, inherit: false, notify: true}));
    }

    function toggleFiltersFlight() {
        $scope.showFiltersFlight = !$scope.showFiltersFlight;
        $rootScope.$broadcast(baseEvents.TRIGGER_FLIGHT_FILTERS);
    }

    function edit() {
        if (flightsUtils.isMultiTripFlight($scope.params.flightType)) {
            $state.go('main.flights.multitrip');
        } else {
            $scope.state.showHeader = !$scope.state.showHeader;
        }
    }

    function swapLocationsInAllSegments() {
        $scope.tempParams.TicketSearchSegments = $scope.tempParams.TicketSearchSegments
            .map((segment) => ({
                ...segment,
                _arrival: segment._departure,
                _departure: segment._arrival,
            }));
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/flights/flightsHeaderBaseCtrl.js